jQuery(document).ready(function($){

  // This first section is all about formatting the content correctly for tabs

  var productDescriptionDivClass = '.product-page-container--product-info--description';
  // Add the opening list tag before the first H5 within the description
  $(productDescriptionDivClass + ' h5:first-of-type')
    .before('<ul class="nav nav-tabs tabs" />');

  // Loop through each H5 in the description
  $(productDescriptionDivClass + ' h5').each(function(index, value) {
    // Assign them each a number, in order
    var num = index + 1;

    // For each H5, wrap everything from after the heading to just before the next one in a div
    // Give each div a unique ID that includes those assigned numbers
    $(this)
      .nextUntil('h5,hr')
      .wrapAll('<div class="tab-content" id="content-tab' + num + '" />');

    // For each h5, wrap the H5 itself in a list item and an anchor link to the div
    $(this)
      .contents()
      .unwrap()
      .wrap('<li class="single-tab"><a href="#tab' + num + '" data-toggle="tab"></a></li>');
  });

  // Wrap the whole list and the tab content divs in a surrounding div
  $('ul.tabs, .tab-content').wrapAll('<div class="tab-area" />');

  // Move that surrounding div after the form
  $('.tab-area').appendTo('.content');

  // Loop through the list items (the tab headers)
  $('.single-tab').each(function() {
    // Move them into the list element
    $(this).appendTo('ul.tabs');
  });


  // The rest of this is the actual tab functionality, from http://www.jacklmoore.com/notes/jquery-tabs/

  $('ul.tabs').each(function() {

    // For each set of tabs, we want to keep track of the active tab and its
    // associated content
    var $links = $(this).find('a');
    var $tabs = $(this).find('li');

    // If the location.hash matches one of the links, use that as the active tab.
    // If no match is found, use the first link as the initial active tab.
    var $activeLink = $($links.filter('[href="' + location.hash + '"]')[0] || $links[0]);
    var $activeTab = $activeLink.parent('li');
    var $activeContent = linkedDiv($activeLink);
    $activeLink.addClass('active');
    $activeTab.addClass('active');
    $activeContent.show();

    // Hide the remaining content
    $links.not($activeLink).each(function() {
      linkedDiv($(this)).hide();
    });

    $tabs.not($activeTab).removeClass('active');

    // Bind the click event handler
    $(this).on('click', 'a', function(e) {
      e.preventDefault();

      // Make the old tab inactive.
      $activeLink.removeClass('active');
      $activeTab.removeClass('active');
      $activeContent.hide();

      // Update the variables with the new link and content
      $activeLink = $(this);
      $activeTab = $activeLink.parent('li');
      $activeContent = linkedDiv($activeLink);

      // Make the tab active.
      $activeLink.addClass('active');
      $activeTab.addClass('active');
      $activeContent.show();
    });
  });
});

function linkedDiv(tabLink) {
  return $('#content-' + $(tabLink).attr('href').substring(1));
}
